const DateFormatterComponent =({date}) => {
    return (
      <>
        {new Date(date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "2-digit",
        })}{" "}
      </>
    );
}

export default DateFormatterComponent